<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="flex justify-start gap-5">
            <hts-select-node
                v-model="filters.node"
                v-model:name="filters.nodeName"
                :label="$t('labels.node')"
                :items="initCustomer"
                class="max-w-96 max-h-96" />

            <hts-select-cooperator
                v-model="filters.customer"
                v-model:name="filters.customerName"
                type-cooperator="CUSTOMER"
                :label="$t('labels.customer')"
                :items="initCustomer"
                class="max-w-96 max-h-96" />
        </div>

        <div class="mt-5">
            <h2>
                Thống kê thời gian trung bình hoàn thành tác vụ
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers()"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)
const contTypes = [
  {
    key: 20,
    title: $t('labels.20f')
  },
  {
    key: 40,
    title: $t('labels.40f')
  },
  {
    key: 45,
    title: $t('labels.45f')
  }
]

const vehicleCategories = ref<null | Array<any>>()

onBeforeMount(() => {
  getVehicleCategories()
})

const getVehicleCategories = () => {
  const api = $urlAdmin.vehicle.category.getAll

  $api(api).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      vehicleCategories.value = resData.data || []
    }
  })
}

const headers = () => {
  let headersDefault = [
    {
      field: 'name',
      headerName: $t('labels.task')
    }
  ] as any[]

  const headersCont: any = [
    ...contTypes.map((type) => {
      return {
        headerName: type.title,
        sortable: false,
        valueGetter: (params: any) => {
          const { completionTimes, completionTimesActual } = params.data
          const time = completionTimes?.contCategory?.[type.key]?.averageTime
          const eAverageTime = typeof time === 'number' ? `${$formatters.formatNumber(time)} giờ` : '-'

          const timeActual = completionTimesActual?.contCategory?.[type.key]
          const eAverageTimeActual = typeof timeActual === 'number' ? `${$formatters.formatNumber(timeActual)} giờ` : '-'

          return `${eAverageTime} / ${eAverageTimeActual}`
        }
      }
    })
  ]

  const headersVehicle: any = [
    ...(vehicleCategories?.value?.map((item: any) => {
      const id = item._id
      return {
        headerName: item.name,
        sortable: false,
        valueGetter: (params: any) => {
          const { completionTimes, completionTimesActual } = params.data
          const time = completionTimes?.vehicleCategory?.[id]?.averageTime
          const eAverageTime = typeof time === 'number' ? `${$formatters.formatNumber(time)} giờ` : '-'

          const timeActual = completionTimesActual?.vehicleCategory?.[id]
          const eAverageTimeActual = typeof timeActual === 'number' ? `${$formatters.formatNumber(timeActual)} giờ` : '-'

          return `${eAverageTime} / ${eAverageTimeActual}`
        }
      }
    }) || [])
  ]

  headersDefault = headersDefault.concat(headersCont)
  headersDefault = headersDefault.concat(headersVehicle)

  return headersDefault
}

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getTask, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)

const initCustomer = [
  {
    _id: 'all',
    name: $t('labels.all')
  }
]
</script>
